import { Product } from '../App'
export const products: Product[] = [
  // Electronics - Phones
  {
    id: 1,
    name: 'iPhone 13 Pro (Refurbished)',
    category: 'electronics',
    subcategory: 'phones',
    price: 699.99,
    image:
      'https://images.unsplash.com/photo-1632661674596-df8be070a5c5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Refurbished iPhone 13 Pro in excellent condition. Features a 6.1-inch Super Retina XDR display, A15 Bionic chip, and a professional camera system. Battery health at 92%. Comes with a 6-month warranty.',
    featured: true,
  },
  {
    id: 2,
    name: 'Samsung Galaxy S21 (Used)',
    category: 'electronics',
    subcategory: 'phones',
    price: 449.99,
    image:
      'https://images.unsplash.com/photo-1610945264803-c22b62d2a7b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Used Samsung Galaxy S21 in good condition. Features a 6.2-inch Dynamic AMOLED display, Exynos 2100 processor, and a versatile triple camera setup. Minor scratches on the back. Comes with original charger.',
    featured: false,
  },
  {
    id: 3,
    name: 'Google Pixel 6 (Like New)',
    category: 'electronics',
    subcategory: 'phones',
    price: 499.99,
    image:
      'https://images.unsplash.com/photo-1635870723802-e88d76ae3189?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Google Pixel 6 in like-new condition. Features a 6.4-inch OLED display, Google Tensor chip, and an impressive camera system. Includes original packaging and accessories. 90-day warranty included.',
    featured: true,
  },
  // Electronics - Laptops
  {
    id: 4,
    name: 'MacBook Pro 2021 (Refurbished)',
    category: 'electronics',
    subcategory: 'laptops',
    price: 1499.99,
    image:
      'https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Refurbished 14-inch MacBook Pro with M1 Pro chip. Features 16GB RAM, 512GB SSD, and a stunning Liquid Retina XDR display. Battery cycle count under 100. Comes with original charger and a 1-year warranty.',
    featured: true,
  },
  {
    id: 5,
    name: 'Dell XPS 15 (Used)',
    category: 'electronics',
    subcategory: 'laptops',
    price: 1199.99,
    image:
      'https://images.unsplash.com/photo-1593642702909-dec73df255d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Used Dell XPS 15 in excellent condition. Features an Intel Core i7 processor, 16GB RAM, 1TB SSD, and a 15.6-inch 4K UHD display. Minor wear on the keyboard. Includes charger and protective case.',
    featured: false,
  },
  // Electronics - Cameras
  {
    id: 6,
    name: 'Sony Alpha a7 III (Used)',
    category: 'electronics',
    subcategory: 'cameras',
    price: 1699.99,
    image:
      'https://images.unsplash.com/photo-1516724562728-afc824a36e84?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Used Sony Alpha a7 III mirrorless camera in excellent condition. Features a 24.2MP full-frame sensor, 5-axis image stabilization, and 4K video recording. Shutter count under 10,000. Includes original box, battery, and charger.',
    featured: true,
  },
  {
    id: 7,
    name: 'Canon EOS R6 (Like New)',
    category: 'electronics',
    subcategory: 'cameras',
    price: 2299.99,
    image:
      'https://images.unsplash.com/photo-1621520291095-aa6c7137f048?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Canon EOS R6 in like-new condition. Features a 20.1MP full-frame sensor, DIGIC X processor, and in-body image stabilization. Includes RF 24-105mm f/4L IS USM lens, original packaging, and accessories.',
    featured: false,
  },
  // Precious Metals - Gold
  {
    id: 8,
    name: '1 oz Gold Bar (999.9 Fine)',
    category: 'metals',
    subcategory: 'gold',
    price: 2050.0,
    image:
      'https://images.unsplash.com/photo-1610375461369-d613b564ed40?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      '1 troy ounce gold bar with 999.9 fine purity. Manufactured by a LBMA-approved refiner. Comes in sealed assay card with unique serial number and certification of authenticity.',
    featured: true,
  },
  {
    id: 9,
    name: 'American Gold Eagle Coin (1 oz)',
    category: 'metals',
    subcategory: 'gold',
    price: 2150.0,
    image:
      'https://images.unsplash.com/photo-1605792657660-596af9009e82?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      "1 oz American Gold Eagle coin, one of the world's most recognized gold bullion coins. Contains 1 troy ounce of pure gold, backed by the U.S. government for weight and purity. Excellent condition with minimal handling marks.",
    featured: false,
  },
  // Precious Metals - Silver
  {
    id: 10,
    name: '100 oz Silver Bar (999 Fine)',
    category: 'metals',
    subcategory: 'silver',
    price: 2850.0,
    image:
      'https://images.unsplash.com/photo-1589108157146-8e297398193b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      '100 troy ounce silver bar with 999 fine purity. Cast bar with stamped weight, purity, and serial number. Excellent for investment and wealth preservation.',
    featured: true,
  },
  {
    id: 11,
    name: 'Canadian Silver Maple Leaf Coins (Tube of 25)',
    category: 'metals',
    subcategory: 'silver',
    price: 775.0,
    image:
      'https://images.unsplash.com/photo-1621231514149-c3c7c7918ae6?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      'Tube of 25 Canadian Silver Maple Leaf coins, each containing 1 troy ounce of 9999 fine silver. Features the iconic maple leaf design. Brilliant uncirculated condition.',
    featured: false,
  },
  // Precious Metals - Platinum
  {
    id: 12,
    name: '1 oz Platinum Bar (999.5 Fine)',
    category: 'metals',
    subcategory: 'platinum',
    price: 1050.0,
    image:
      'https://images.unsplash.com/photo-1607344645866-009c320c5ab8?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    description:
      '1 troy ounce platinum bar with 999.5 fine purity. Minted bar with assay certificate. Excellent for diversification of precious metals portfolio.',
    featured: true,
  },
]
export const categories = [
  {
    id: 'phones',
    title: 'Phones',
    image:
      'https://images.unsplash.com/photo-1580910051074-3eb694886505?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    count: 3,
  },
  {
    id: 'laptops',
    title: 'Laptops',
    image:
      'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    count: 2,
  },
  {
    id: 'cameras',
    title: 'Cameras',
    image:
      'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    count: 2,
  },
  {
    id: 'gold',
    title: 'Gold',
    image:
      'https://images.unsplash.com/photo-1610375461369-d613b564ed40?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    count: 2,
  },
  {
    id: 'silver',
    title: 'Silver',
    image:
      'https://images.unsplash.com/photo-1589108157146-8e297398193b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    count: 2,
  },
  {
    id: 'platinum',
    title: 'Platinum',
    image:
      'https://images.unsplash.com/photo-1607344645866-009c320c5ab8?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
    count: 1,
  },
]
